import { motion } from 'framer-motion';

export const Reveal = ({ children, delay = 0, className = '', y = 28 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    >
        {children}
    </motion.div>
);

export const Overline = ({ children, className = '' }) => (
    <span className={`font-mono text-xs uppercase tracking-[0.25em] text-deepteal ${className}`}>
        {children}
    </span>
);

export const SectionHeader = ({ overline, title, description, dark = true, className = '' }) => (
    <div className={`max-w-3xl ${className}`}>
        {overline && <Overline>{overline}</Overline>}
        <h2 className={`mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-snug text-balance ${dark ? 'text-slate-50' : 'text-ink'}`}>
            {title}
        </h2>
        {description && (
            <p className={`mt-5 text-base sm:text-lg leading-relaxed ${dark ? 'text-slate-400' : 'text-[#475569]'}`}>
                {description}
            </p>
        )}
    </div>
);
